import { legacy_createStore as createStore } from 'redux'
import { ACTIVE_COMPANY_KEY } from './config/Constants'

const initialState = {
  sidebarShow: true,
  theme: 'light',
  activeCompanyId: localStorage.getItem(ACTIVE_COMPANY_KEY) || null,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
